/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import { POST, PUT } from '/client/src/api/';
import Modal from '/client/src/components/Modal';
import Loader from '/client/src/components/Loader';
import { currency } from '/client/src/constants/';
import SimpleCheckbox from '/client/src/components/forms/checkbox';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer.js';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { timeerOffModal } from '/client/src/constants/';
import CssPinner from '/client/src/components/csspinner';
import { format } from '/client/src/utils/amountTransformation';
import { convertToLocalTime } from '/client/src/utils/jstz';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleShowPaymentModal: (boolean) => void,
  showPaymentModalOrderId: null | number | string,
  eventData?: {
    begin_time_utc: string,
    time_zone_id: string,
    show_event_time_and_date: boolean,
    name: string

  },
  updateRefundList: () => void
};

type ConfirmVoidModalContentPropsType = {
  handleVoidRefund: () => void,
  confirmWord: string
};

const ConfirmVoidModalContent = ({
  handleVoidRefund,
  confirmWord
}: ConfirmVoidModalContentPropsType): React.Element<> => {
  const [confirmWordInput, setConfirmWordInput] = React.useState('');
  const isValid = _.toLower(confirmWordInput) === confirmWord;

  const handleConfirmWord = (e: any) => {
    const confirmWordUpperCase = confirmWord.toUpperCase();

    if (
      confirmWord[confirmWordInput.length] === e.key ||
      ((!!window.event.shiftKey || e.getModifierState('CapsLock')) && confirmWordUpperCase[confirmWordInput.length] === e.key)
    ) {
      setConfirmWordInput(prevState => prevState + e.key.toLowerCase());
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleConfirmWord);
    return () => {
      document.removeEventListener('keydown', handleConfirmWord);
    };
  });

  return (
    <>
      <span className='refund-confirm-text-web'>Type "{confirmWord}" to confirm</span>
      <span className='refund-confirm-text-mob'>Tap each letter to confirm</span>

      <div className='refund-confirm-word'>
        {
          confirmWord.split('').map((el: string, i: number) => (
            <span
              key={i}
              style={{ color: confirmWordInput[i] === el ? '#0094ff' : '#afafaf' }}
              onClick={() => handleConfirmWord({ key: el })}
            >
              {el}
            </span>
          ))
        }
      </div>

      {isValid &&
        <span className='custom-pb-container' style={{ position: 'absolute', bottom: '1rem', right: '1rem' }}>
          <BtnLoader
            label='Confirm'
            handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
              handleVoidRefund(setStatus);
            }}
          />
        </span>
      }
    </>
  );
};

class EventPageDetailCustomersPaymentModal extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  state = {
    data: null,
    isShow: null,
    isVoidChecked: false,
    isVoidEmailSendChecked: true,
    isRefundEmailSendChecked: true,
    isVoidCheckedArr: [],
    isAlreadyVoided: [],
    isRefundCheckedArr: [],
    isRefundCheckedCodes: [],
    refundDonations: [],
    isVoidCheckedCodes: [],
    isLocked: false,
    refundMessage: '',
    attendees: [],
    isIssueRefundBtnShow: false
  }

  handleClose = (): any => {
    const { handleShowPaymentModal } = this.props;

    handleShowPaymentModal(false);
  };

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      const res = _.get(response, 'data.result', []);
      const attendees = _.get(response, 'data.result.attendees', []);
      const isIssueRefundBtnShow = attendees.some(x => _.get(x, 'ticket.merchant_revenue', 0) > 0)
        || _.get(response, 'data.result.merchant_revenue', 0) > 0;

      this.setState({
        data: res
      });

      if (_.size(res)) {
        const _isVoidCheckedArr = [];

        _.map(res.attendees, (r: {}) => {
          if (r.has_voided) {
            _isVoidCheckedArr.push(r.id);
          }
        });

        this.setState({
          isVoidCheckedArr: _isVoidCheckedArr,
          isIssueRefundBtnShow
        });
      }
    }
  }

  handleSimpleChangeCheckbox = (status: boolean, name: string) => {
    this.setState({
      [name]: status
    });
  }

  handleChangeCheckbox = (status: boolean, name: string, id: string | number) => {
    const _isVoidCheckedArr = this.state.isVoidCheckedArr;
    const _isRefundCheckedArr = this.state.isRefundCheckedArr;
    const _isRefundCheckedCodes = this.state.isRefundCheckedCodes;
    const _isVoidCheckedCodes = this.state.isVoidCheckedCodes;
    const _attendees = this.state.attendees;
    const currentTicket = _.find(this.state.data.attendees, (a: {}): {} => _.toString(a.id) === _.toString(id));
    const attendeExist = _.find(_attendees, (a: {}): {} => _.toString(a.id) === _.toString(currentTicket.id));

    let attende = attendeExist ? attendeExist : { id: _.toString(currentTicket.id) }; // get exist item or create new

    if (name === 'isVoidChecked') {
      if (status) {
        _isVoidCheckedArr.push(id);
        _isVoidCheckedCodes.push(currentTicket.check_code);

        _.set(attende, 'need_void', true);
      } else {
        _.remove(_isVoidCheckedArr, (n: string | number): boolean => _.toString(n) === _.toString(id));
        _.remove(_isVoidCheckedCodes, (n: string): boolean => n === currentTicket.check_code);
        _.unset(attende, 'need_void');

        if (currentTicket.has_voided) {
          this.handleCancelVoid(currentTicket.event_id, currentTicket.barcode);
        }
      }

      this.setState({
        [name]: status,
        isVoidCheckedArr: _isVoidCheckedArr
      });
    } else if (name === 'isRefundChecked') {
      if (status) {
        _isRefundCheckedArr.push(id);
        _isRefundCheckedCodes.push(currentTicket.check_code);

        attende = _.find(_attendees, (a: {}): {} => _.toString(a.id) === _.toString(currentTicket.id)) || { id: _.toString(currentTicket.id) };
        _.set(attende, 'is_full_refund', true);
        _.set(attende, 'amount_to_refund', currentTicket.ticket.amount);
      } else {
        _.remove(_isRefundCheckedArr, (n: string | number): boolean => _.toString(n) === _.toString(id));
        _.remove(_isRefundCheckedCodes, (n: string): boolean => n === currentTicket.check_code);
        _.unset(attende, 'is_full_refund');
        _.unset(attende, 'amount_to_refund');

        if (currentTicket.has_voided) {
          this.handleCancelVoid(currentTicket.event_id, currentTicket.barcode);
        }
      }

      this.setState({
        [name]: status,
        isRefundCheckedArr: _isRefundCheckedArr
      });
    } else {
      this.setState({
        [name]: status
      });
    }

    _.remove(_attendees, (n: {}): boolean => _.toString(n.id) === _.toString(attende.id));

    if (!_.size(_.omit(attende, ['id']))) {
      this.setState({
        attendees: _attendees
      });
    } else {
      this.setState({
        attendees: [
          ..._attendees,
          attende
        ]
      });
    }

    this.msgText();
  }
  handleChangeDonationCheckbox = (status: boolean, name: string, donation: {}) => {
    const _isRefundCheckedArr = this.state.isRefundCheckedArr;

    let _refundDonations = this.state.refundDonations;

    if (status) {
      _isRefundCheckedArr.push(donation.id);
      _refundDonations.push(donation);
    } else {
      _.remove(_isRefundCheckedArr, (n: string | number): boolean => _.toString(n) === _.toString(donation.id));
      _refundDonations = [];
    }

    this.setState({
      [name]: status,
      isRefundCheckedArr: _isRefundCheckedArr,
      refundDonations: _refundDonations
    }, () => {
      this.msgText();
    });
  }

  msgText = () => {
    const { eventData } = this.props;
    const { data, refundDonations } = this.state;
    const voidCodes = this.state.isVoidCheckedCodes;
    const refundCodes = this.state.isRefundCheckedCodes;

    const totalRefund = (): number => {
      let sum = 0;

      _.map(refundCodes, (i: string) => {
        _.find(data.attendees, (a: {}): {} => {
          if (a.check_code === i) sum += a.ticket.amount;
        });
      });
      _.map(refundDonations, (d: string) => {
        sum += d.amount;
      });

      return sum;
    };

    if (voidCodes.length === 0 && refundCodes.length === 0 && refundDonations.length === 0) {
      this.setState({
        refundMessage: ''
      });
      return;
    }

    const hasVoid = voidCodes.length > 0;

    const hasRefund = totalRefund() > 0;

    let msg = `Hello ${data.customer_first_name}, \n`;

    if (hasRefund) {
      let ticketRefund = '';

      if (refundCodes.length > 0) {
        ticketRefund = (
          refundCodes.length === 1 ?
            ' for your ticket with ticket code: '
            :
            'for your tickets with ticket codes: '
        ) + refundCodes.join(', ');
      }

      // let timestamp = ` on  ${moment.formatDate(eventData.begin_time_utc, eventData.time_zone_id)}`;
      // TODO: timezone like "Pacific Standard Time" no work, copy from NEST

      const timestamp = ` on ${convertToLocalTime(eventData.begin_time_utc, eventData.time_zone_id, 'DD/MM/YY h:mm a z')}`;

      const eventTime = eventData.show_event_time_and_date ? timestamp : '';

      // eslint-disable-next-line
      msg += `\nThe amount of ${format(currency[data.currency], totalRefund())} will be refunded ${ticketRefund} for ${eventData.name}${eventTime}. `;

      if (hasVoid) {
        msg += voidCodes.length === 1 ?
          `The ticket code: ${voidCodes.join(', ')} has been voided. `
          :
          `The ticket codes: ${voidCodes.join(', ')} have been voided. `;
      }

      // eslint-disable-next-line
      msg += '\n\nAlthough this refund has been processed, it may take up to 7 business days for the refund to appear on your bank or credit card statement. ';
    }

    if (hasVoid && !hasRefund) {
      msg += voidCodes.length === 1 ?
        `Your ticket with ticket code: ${voidCodes.join(', ')} for ${eventData.name} has been voided. `
        :
        `Your tickets with ticket codes: ${voidCodes.join(', ')} for ${eventData.name} have been voided. `;
    }

    msg += `\n\nPlease contact your event organizer if you have any questions: ${this.context.profileCurrent.email}`;

    this.setState({
      refundMessage: msg
    });
  };

  handleCancelVoid = async (eventId: string | number, barcode: string | number) => {
    const modalBody = document.querySelector('.EventPageDetailCustomersModal.modal-dialog');

    try {
      CssPinner(modalBody, true);

      await PUT(`/api/v1/1/events/${eventId}/attendees/${barcode}/cancel_void`);

      CssPinner(modalBody, false);
    } catch (e) {
      CssPinner(modalBody, false);
      console.log(e);
      console.error('Can\'t cancel void');

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t cancel void'
      });
    }
  }

  handleChangeView = (view: string | null) => {
    if (!view) this.handleResetSelected();
    const attendees = _.get(this.state, 'data.attendees', []);
    const paidAttendees = attendees.filter(x => _.get(x, 'ticket.merchant_revenue', 0) > 0);

    this.setState({
      isShow: view,
      data: {
        ...this.state.data,
        paidAttendees
      }
    });
  }

  handleResetSelected = () => {
    const _isAlreadyVoided = [];

    _.map(this.state.data.attendees, (r: {}) => {
      if (r.has_voided) _isAlreadyVoided.push(r.id);
    });

    this.setState({
      isVoidCheckedArr: _isAlreadyVoided,
      isRefundCheckedArr: [],
      isRefundCheckedCodes: [],
      isVoidCheckedCodes: [],
      attendees: []
    });
  }

  setRefundMessage = (refundMessage: string) => {
    this.setState({ refundMessage });
  }

  handleVoidRefund = async (setStatus: (string) => void) => {
    const {
      isLocked,
      // data,
      isVoidEmailSendChecked,
      refundMessage,
      refundDonations
    } = this.state;

    if (isLocked) {
      console.warn('Already locked');
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    const _data = {
      donation_items: refundDonations.map((el: {}): {} => {
        return {
          amount_to_refund: el.amount,
          id: el.id,
          is_full_refund: true
        };
      }),
      refund_message: refundMessage.replace(/\n/g, '<br/>'),
      send_email: isVoidEmailSendChecked,
      attendees: this.state.attendees
    };

    try {
      const { success } = await POST(`/api/v1/1/orders/${this.props.showPaymentModalOrderId}/refund_and_void`, _data);

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');
          this.props.updateRefundList();
          this.handleClose();

          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Successfully'
          });
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'Can\'t save data'
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, timeerOffModal * 3);
      });
    }
  }

  handleVoidRefundConfirm = (type: string, arrayToCheck: []) => {
    if (!_.size(arrayToCheck)) {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'warning',
        systemDialogTitle: 'Hmmm...',
        systemDialogContent: `Please select at least one ticket to ${type}.`
      });
    } else {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'warning',
        systemDialogTitle: 'Confirm',
        systemDialogContent: <ConfirmVoidModalContent handleVoidRefund={this.handleVoidRefund} confirmWord={type} />
      });
    }
  }
  handleSelectAllRefunds = (status: boolean) => {
    const { order_donation_items } = this.state.data;
    const attendees = this.state.data.attendees.map((el: {}): {} => ({
      id: el.id,
      check_code: el.check_code,
      is_full_refund: true,
      amount_to_refund: el.ticket.amount
    }));

    this.setState({
      isRefundCheckedArr: status ? [...attendees.map(el => el.id), ...order_donation_items.map(el => el.id)] : [],
      isRefundCheckedCodes: status ? attendees.map(el => el.check_code) : [],
      attendees: status ? attendees : [],
      refundDonations: order_donation_items
    }, (): void => this.msgText());
  }

  render(): React.Element {
    const { isOpen, showPaymentModalOrderId, eventData } = this.props;
    const { data, isShow, refundMessage, isRefundEmailSendChecked, isIssueRefundBtnShow } = this.state;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        altView
        isScrollable
      >
        <div className="modal-dialog modal-lg customModal EventPageDetailCustomersModal modal-table-filter" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span className="icon icon-ticket modal-icon modal-icon-pink" style={{ marginRight: '2rem' }} />
                <span>
                  {isShow === 'void' && 'Void Tickets'}
                  {isShow === 'refund' && 'Issue Refund'}
                  {!isShow && 'Payment Summary'}
                </span>
              </h4>
            </div>
            <div className="modal-body" style={{ paddingBottom: '0', minHeight: 300, position: 'relative' }}>
              <Loader
                url={`/api/v1/1/orders/${showPaymentModalOrderId}`}
                onLoaded={this.handleLoaded}
              >
                {data &&
                  <>
                    <table className="table table-default">
                      <tbody>
                        <tr className="even">
                          <td className="col-xs-2">
                            <span data-bind="i18n:$L.purchaser">Purchaser</span>:&nbsp;
                          </td>
                          <td>{data.customer_first_name} {data.customer_last_name}</td>
                        </tr>

                        <tr>
                          <td><span data-bind="i18n:$L.email">Email</span>:</td>
                          <td data-bind="text:email">{data.customer_email_address}</td>
                        </tr>

                        <tr className="even">
                          <td><span>Phone</span>:</td>
                          <td data-bind="text:phone">{data.customer_phone_number}</td>
                        </tr>

                        <tr>
                          <td><span lang-key="manage.refund_page.date_purchased">Date Purchased</span>:</td>
                          <td data-bind="text:datePurchased">
                          {convertToLocalTime(_.get(data, 'creation_time', ''), eventData.time_zone_id, 'MM/DD/YY h:mm a z')}
                          </td>
                        </tr>

                        <tr className="even">
                          <td><span lang-key="manage.refund_page.total_payment">Total Payment</span>:</td>
                          <td data-bind="$money:totalPayment,$symbol:currency">
                            {format(currency[data.currency], data.amount)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ overflow: 'auto' }}>
                      {!!_.size(data.attendees) &&
                        <table className="table table-default">
                          <thead>
                            <tr className="no-bg" style={{ fontWeight: 'bold' }}>
                              <th>Guests</th>
                              <th>Ticket Type</th>
                              <th>Ticket Value</th>
                              <th>Last 4 CC</th>
                              {isShow === 'void' &&
                                <th style={{ textAlign: 'center' }}>Void Ticket</th>
                              }
                              {!isShow &&
                                <th>Ticket Status</th>
                              }
                              {isShow !== 'void' &&
                                <th style={{ width: '100px' }}>Refunded</th>
                              }

                              {isShow === 'refund' &&
                                <>
                                  <th>Refund</th>
                                  <th>Void Ticket</th>
                                </>
                              }
                            </tr>
                          </thead>
                          <tbody data-bind="foreach:attendees">
                            {_.map(isShow === 'refund' ? data.paidAttendees : data.attendees, (at: {}, ati: number): React.Element<'tr'> => {
                              return (
                                <tr
                                  key={`EventPageDetailCustomersPaymentModal-attendees-${ati}`}
                                  className={ati % 2 === 0 ? 'even' : 'odd'}
                                >
                                  <td data-bind="text:attendee_name">{at.first_name} {at.last_name}</td>
                                  <td data-bind="text:ticket_name">{at.ticket.name}</td>
                                  <td data-bind="$money:merchant_revenue,$symbol:$parent.currency">
                                    {format(currency[data.currency], at.ticket.merchant_revenue)}
                                  </td>
                                  <td data-bind="text:card_last4">{at.order.card_last4}</td>
                                  {!isShow &&
                                    <td data-bind="text:ticket_status">{at.has_voided ? 'void' : 'valid'}</td>
                                  }
                                  {isShow !== 'void' &&
                                    <td data-bind="$money:refunded,$symbol:$parent.currency">
                                      {format(currency[data.currency], at.refund_amount)}
                                    </td>
                                  }

                                  {isShow === 'refund' &&
                                    <>
                                      <td style={{ textAlign: 'center' }} data-td='checkbox'>
                                        {at.ticket.merchant_revenue !== 0 && at.refund_amount < at.ticket.amount &&
                                          <SimpleCheckbox
                                            checked={_.indexOf(this.state.isRefundCheckedArr, at.id) !== -1}
                                            callBack={(status: boolean) => {
                                              this.handleChangeCheckbox(status, 'isRefundChecked', at.id);
                                            }}
                                          />
                                        }
                                      </td>
                                    </>
                                  }

                                  {isShow &&
                                    <>
                                      <td style={{ textAlign: 'center' }} data-td='checkbox'>
                                        <SimpleCheckbox
                                          checked={_.indexOf(this.state.isVoidCheckedArr, at.id) !== -1}
                                          callBack={(status: boolean) => {
                                            this.handleChangeCheckbox(status, 'isVoidChecked', at.id);
                                          }}
                                          style={{ pointerEvents: `${at.has_voided ? 'none' : 'auto'}` }}
                                        />
                                      </td>
                                    </>
                                  }

                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      }
                      {!!_.size(data.order_donation_items) && isShow !== 'void' &&
                        <div style={{ overflow: 'auto' }}>
                          <table className="table table-default">
                            <thead>
                              <tr className="no-bg" style={{ fontWeight: 'bold' }}>
                                <th>Donation Name</th>
                                <th>Donation Amount</th>
                                <th>CC Fee</th>
                                <th style={{ width: '100px' }}>Refunded</th>
                                {isShow === 'refund' &&
                                  <>
                                    <th>Refund</th>
                                    <th style={{ width: '130px' }} />
                                  </>
                                }
                              </tr>
                            </thead>
                            <tbody>
                              {_.map(data.order_donation_items, (d: {}, i: number): React.Element<'tr'> => {
                                return (
                                  <tr
                                    key={`EventPageDetailCustomersPaymentModal-donations-${i}`}
                                    className={i % 2 === 0 ? 'even' : 'odd'}
                                  >
                                    <td>{d.donation_snapshot.name}</td>
                                    <td> {format(currency[data.currency], d.amount)}</td>
                                    <td> {format(currency[data.currency], d.total_fee)}</td>
                                    <td> {format(currency[data.currency], d.refund_amount)}</td>
                                    {isShow === 'refund' &&
                                      <>
                                        <td style={{ textAlign: 'center' }} data-td='checkbox'>
                                          {d.merchant_revenue !== 0 &&
                                            <SimpleCheckbox
                                              checked={_.indexOf(this.state.isRefundCheckedArr, d.id) !== -1}
                                              callBack={(status: boolean) => {
                                                this.handleChangeDonationCheckbox(status, 'isRefundChecked', d);
                                              }}
                                            />
                                          }
                                        </td>
                                        <td />
                                      </>
                                    }
                                  </tr>
                                );
                              })
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      {isShow === 'void' &&
                      <>
                       <div className='refund-checkbox-area'>
                        <SimpleCheckbox
                          label='Send Email'
                          checked={this.state.isVoidEmailSendChecked}
                          callBack={(status: boolean) => {
                            this.handleSimpleChangeCheckbox(status, 'isVoidEmailSendChecked');
                          }}
                        />
                        </div>
                        {isRefundEmailSendChecked &&
                            <div className="form-group">
                              <label htmlFor="refundMessage">Add customized email message to guests here</label>
                              <textarea
                                className="form-control EventPageDetailCustomersModal-textarea"
                                id="refundMessage"
                                rows={refundMessage.length ? 10 : 5}
                                value={refundMessage}
                                onChange={(e: {}): void => this.setRefundMessage(e.target.value)}
                              />
                            </div>
                          }
                        </>
                      }

                      {isShow === 'refund' &&
                        <>
                          <div className='refund-checkbox-area'>
                            <SimpleCheckbox
                              label='Send Email'
                              checked
                              callBack={(status: boolean) => {
                                this.handleSimpleChangeCheckbox(status, 'isRefundEmailSendChecked');
                              }}
                            />
                            <SimpleCheckbox
                              label='Refund all'
                              callBack={(status: boolean) => {
                                this.handleSelectAllRefunds(status);
                              }}
                            />
                          </div>
                          {isRefundEmailSendChecked &&
                            <div className="form-group">
                              <label htmlFor="refundMessage">Add customized email message to guests here</label>
                              <textarea
                                className="form-control EventPageDetailCustomersModal-textarea"
                                id="refundMessage"
                                rows={refundMessage.length ? 10 : 5}
                                value={refundMessage}
                                onChange={(e: {}): void => this.setRefundMessage(e.target.value)}
                              />
                            </div>
                          }
                        </>
                      }
                    </div>
                  </>
                }
              </Loader>
            </div>
            <div
              className="modal-footer"
              style={!data ? {
                opacity: 0.75,
                pointerEvents: 'none'
              } : {}}
            >
              {isShow === 'void' ?
                <>
                  <button className="btn btn-gray" onClick={(): any => this.handleChangeView(null)}>Cancel</button>
                  <button
                    className="btn btn-pink"
                    onClick={(): void => this.handleVoidRefundConfirm('void', this.state.isVoidCheckedArr)}
                  >Confirm</button>
                </>
                : ''
              }
              {isShow === 'refund' ?
                <>
                  <button className="btn btn-gray" onClick={(): any => this.handleChangeView(null)}>Cancel</button>
                  <button
                    className="btn btn-pink"
                    onClick={(): void => this.handleVoidRefundConfirm('refund', this.state.isRefundCheckedArr)}
                  >Confirm</button>
                </>
                : ''
              }
              {!isShow ?
                <>
                  <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
                  {
                    data && !!_.size(data.attendees) &&
                    <button className="btn btn-pink" onClick={(): any => this.handleChangeView('void')}>
                      Void Tickets
                    </button>
                  }

                  {isIssueRefundBtnShow &&
                    <button className="btn btn-pink" onClick={(): any => this.handleChangeView('refund')}>
                      Issue Refund
                    </button>
                  }
                </>
                : ''
              }
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailCustomersPaymentModal;
